import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import AQIChart from '../AQIChart/AQIChart.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
let seriesdata = [
    {
        "name":"Good",
        "color": "#009688",
        "series": [[60,0]]
    },
    {
        "name":"Moderate",
        "color": "#e5ce89",
        "series": [[264,0]]
    },
    {
        "name":"Unhealthy",
        "color": "#e5982b",
        "series": [[37,0]]
    },
    {
        "name":"Very Unhealthy",
        "color": "#e57175",
        "series": [[3,0]]
    },
    {
        "name":"Hazardous",
        "color": "#e51c23",
        "series": [[1,0]]
    }
];

seriesdata = seriesdata.map((obj) => {
    obj.series = obj.series.map(val => [val[0],val[1]]).sort((a,b)=>a[0]-b[0]);
    return obj;
})
const chartdata = {
    data: seriesdata,
    xTicks: [0,60,120,180,240],
    yTicks: [0,2],
    xTickFormat: function(val,i) { return val/30+(i==0?" months":"") },
    yTickFormat: function(val,i) { return val; },
    barNumberFormat: function(val,i,j) { return val+(i==0?" days":"")}
}



export default class ChinaPortsProfiles extends React.Component {
    render() {
        return <div className="section card-panel" style={{backgroundColor:"#fff",paddingLeft:"1rem",paddingRight:"1rem"}}>
            <div className="row">
                <div className="col l8 m6 s12">
                    <Markdown>
                        { content['china-profile'].filter((o) => o.type=="text").map((o) => o.value).join("\n\n") }
                    </Markdown>
                </div>
                <div className="col l4 m6 s12">
                    <SubInset hed="Total Days Pollution Standard Index (PSI) Categories Were Reached In 2015"
                        notes={["Note: Singapore publishes data using the local PSI system, which is very similar to AQI. This calculation was made by taking the median value of Singapore's different regional 24-hour PSI values, and determining the highest category reached each day."]}
                        source="Source: Singapore National Environment Agency">
                        <AQIChart {...chartdata}/>
                    </SubInset>
                </div>
            </div>
        </div>    
    }   
}


// WEBPACK FOOTER //
// ./src/js/components/special/PortCityProfiles/ChinaPortsProfiles.jsx